import { machineService } from '_services';
import { session } from '_helpers';
import { ACTIONS_MACHINE } from '_constants/machine.constants';
import alertActions from './alert.actions';

export const receiveMachines = (machines) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < machines.length; i++) {
    byIdObjectToDispatch[machines[i].machineID] = machines[i];
  }

  return {
    type: ACTIONS_MACHINE.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteMachine = (machineId) => ({
  type: ACTIONS_MACHINE.DELETE,
  byId: { [machineId]: null }
});

const getMachines = (accountID) => async (dispatch) => {
  try {
    const resp = await machineService.getAll(accountID);
    if (resp?.[0]?.machineID) {
      dispatch(receiveMachines(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving machines.', e));
  }
  return null;
};

const getAllMachines = () => async (dispatch) => {
  try {
    const resp = await machineService.getAllMachines();
    if (resp?.[0]?.machineID) {
      dispatch(receiveMachines(resp));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error('Error retrieving machines.', e));
  }
  return null;
};

const getMachine = (machineID) => async (dispatch) => {
  try {
    const resp = await machineService.getById(machineID);
    if (resp?.machineID) {
      dispatch(receiveMachines([ resp ]));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error retrieving machine #${machineID}.`, e));
  }
  return null;
};

const addMachine = (machine) => async (dispatch) => {
  try {
    const resp = await machineService.create(machine);
    if (resp?.machineID) {
      dispatch(receiveMachines([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const updMachine = (machine) => async (dispatch) => {
  try {
    const resp = await machineService.update(machine);
    if (resp?.machineID) {
      dispatch(receiveMachines([ resp ]));
      return resp;
    }
  } catch (e) {
    session.checkSession(e);
    dispatch(alertActions.error(e.message, e));
  }
  return null;
};

const delMachine = (machineID) => async (dispatch) => {
  try {
    const resp = await machineService.delete(machineID);
    if (resp?.machineID) {
      dispatch(deleteMachine(resp.machineID));
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error removing machine #${machineID}.`, e));
  }
  return null;
};

const revokeDeviceAccess = (deviceID) => async (dispatch) => {
  try {
    const resp = await machineService.revokeDeviceAccess(deviceID);
    if (resp?.deviceID) {
      return resp;
    }
  } catch (e) {
    dispatch(alertActions.error(`Error revoking device access #${deviceID}.`, e));
  }
  return null;
};

const machineActions = {
  getMachines,
  getMachine,
  addMachine,
  updMachine,
  delMachine,
  getAllMachines,
  revokeDeviceAccess,
};

export default machineActions;
